<app-banner [loading]="loading" [info]="true" [heading]="'Accounts'" [subHeading]="SubHeading">

  <div class="toolbar-content">
    @if (preregUser) {
      <button (click)="onBackBtnClick()" aria-label="Back" class="btn btn-back">
        <i class="fa fa-arrow-left"></i>
        <span>back</span>
      </button>
    }
    @if (!layout.state.fullscreen) {
      <button (click)="layout.setFullscreen(true)" aria-label="Maximise" class="btn btn-back">
        <i class="fa fa-window-maximize"></i>
        <span>maximise</span>
      </button>
    }
    @if (layout.state.fullscreen) {
      <button (click)="layout.setFullscreen(false)" aria-label="Maximise" class="btn btn-back">
        <i class="fa fa-window-restore"></i>
        <span>restore</span>
      </button>
    }
  </div>
</app-banner>
<div class="content no-boxes">
  @if (!preregUser) {
    <div class="row">
      <div class="col-md-3 lookup">
        <app-user-lookup (gotPortalUser)="portalUser = $event" (gotPreregUser)="preregUser = $event"  (gotSsoUser)="ssoUser = $event"></app-user-lookup>
      </div>
      <div class="col-md-9">
        <app-user-list [portalUser]="portalUser" [ssoUser]="ssoUser"></app-user-list>
      </div>
    </div>
  }
</div>
<div class="content no-boxes">
  @if (preregUser) {
    <div class="row">
      <div class="col-md-12">
        <app-user-list [preregUser]="preregUser"></app-user-list>
      </div>
    </div>
  }
</div>

